import { render, staticRenderFns } from "./table83.vue?vue&type=template&id=588b655c&scoped=true&"
import script from "./table83.vue?vue&type=script&lang=js&"
export * from "./table83.vue?vue&type=script&lang=js&"
import style0 from "./table83.vue?vue&type=style&index=0&id=588b655c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b655c",
  null
  
)

export default component.exports